import React, { useState } from "react"
import type { AiSummaryData } from "~/api/snapshot_summaries"

interface AiSummaryBoxProps {
  data: AiSummaryData
}

type TabId =
  | "high_level_summary"
  | "attribution_highlights"
  | "liquidity_events"
  | "new_investments"
  | "cash_flows"

const TABS: { id: TabId; label: string }[] = [
  { id: "high_level_summary", label: "High Level Summary" },
  { id: "attribution_highlights", label: "Attribution Highlights" },
  { id: "liquidity_events", label: "Liquidity Events" },
  { id: "new_investments", label: "New Investments" },
  { id: "cash_flows", label: "Cash Flows" },
]

export default function AiSummaryBox({ data }: AiSummaryBoxProps) {
  const [activeTab, setActiveTab] = useState<TabId>("high_level_summary")

  function renderContent() {
    switch (activeTab) {
      case "high_level_summary":
        return <p className="b-ai-summary-prose">{data.high_level_summary}</p>
      case "attribution_highlights":
        return (
          <ul className="b-ai-summary-list">
            {data.attribution_highlights.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        )
      case "liquidity_events":
        return (
          <ul className="b-ai-summary-list">
            {data.liquidity_events.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        )
      case "new_investments":
        return (
          <ul className="b-ai-summary-list">
            {data.new_investments.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        )
      case "cash_flows":
        return <p className="b-ai-summary-prose">{data.cash_flows}</p>
    }
  }

  return (
    <div className="b-ps-card b-ai-card">
      <div className="b-ps-card__header">
        <h2>AI Summary</h2>
        <span className="b-ai-tag">AI Generated</span>
      </div>

      {/* Desktop tab bar */}
      <div className="b-ai-summary-tabs b-ai-summary-tabs--desktop">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`b-ai-summary-tab${
              activeTab === tab.id ? " active" : ""
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Mobile dropdown */}
      <div className="b-ai-summary-tabs b-ai-summary-tabs--mobile">
        <select
          className="b-ai-summary-select"
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value as TabId)}
        >
          {TABS.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.label}
            </option>
          ))}
        </select>
      </div>

      <div className="b-ps-card__body b-ai-summary-body">{renderContent()}</div>
    </div>
  )
}
